// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NavMenu_nav-menu__header__pUpPz {
  font-size: var(--text-lg);
  font-weight: 700;
  color: #fff;
  margin-bottom: 2.5rem;
}

.NavMenu_nav-menu__list__4KXGi {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

@media screen and (min-width: 1024px) and (max-width: 1280px) {
  .NavMenu_nav-menu__header__pUpPz {
    font-size: var(--text-base);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/DashboardFooter/Sitemap/Navigation/NavMenu/NavMenu.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".nav-menu__header {\n  font-size: var(--text-lg);\n  font-weight: 700;\n  color: #fff;\n  margin-bottom: 2.5rem;\n}\n\n.nav-menu__list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1280px) {\n  .nav-menu__header {\n    font-size: var(--text-base);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nav-menu__header": `NavMenu_nav-menu__header__pUpPz`,
	"nav-menu__list": `NavMenu_nav-menu__list__4KXGi`
};
export default ___CSS_LOADER_EXPORT___;
